<template>
    <app-layout>
        <bax-header-banner :user="this.$store.state.auth.user" :orderStep="isTPN() ? 2 : 3" :order="orderInfo"/>

        <main>
            <div class="bax-section bax-select-patient-wrap bax-drug-detail">
                <div class="container">
                    <order-summary
                        theme="dark"
                        ref="orderSummary"
                        v-on:refresh-order-summary="refreshFormOrderInfo"
                    ></order-summary>

                    <vue-alert v-if="!isTPN()">
                        <p>Adding drugs for:
                            <strong v-if="selectedPatient.firstName">
                                {{ selectedPatient.firstName }} {{ selectedPatient.lastName }}
                            </strong>
                            <strong v-else>--</strong>
                        </p>
                        <p class="ml-auto mt-3 mt-md-0">
                            Patient ID (MRN):
                            <strong v-if="selectedPatient.firstName">
                                {{ generalPatientID }}
                            </strong>
                            <strong v-else>--</strong>
                        </p>
                    </vue-alert>

                    <order-drug-form ref="drugFrom" :patient="selectedPatient" :edit="false" @refreshOrderInfo="refreshOrderInfo" :orderInfo="this.orderInfo"></order-drug-form>
                </div>
            </div>
        </main>
    </app-layout>
</template>

<script>
/* eslint-disable */
import _ from 'lodash';
import AppLayout from '@/components/layout/AppLayout.vue';
import OrderService from '@/core/api/order/order.service';
import OrderDrugService from '@/core/api/order/orderDrug.service';
import OrderSummary from '@/components/order/OrderSummary/OrderSummary.vue';
import PatientSummary from './PatientSummary.vue';
import OrderDrugForm from '@/components/order/OrderDrug/OrderDrugForm.vue';
import { scrollPageToTop } from '@/core/helpers';
import BaxHeaderBanner from '@/components/layout/BaxHeaderBanner.vue';
import tpnMixin from '@/mixins/tpnMixin';

export default {
    name: 'DrugDetail',
    mixins: [tpnMixin],
    components: {
        AppLayout,
        OrderSummary,
        PatientSummary,
        OrderDrugForm,
        BaxHeaderBanner,
    },
    data() {
        return {
            loading: true,
            orderInfo: {},
            selectedPatient: {},
            deleteBox: false,
            deleteDrug: null,
        };
    },
    methods: {
        refreshOrderInfo() {
            this.$refs.orderSummary.getOrderInfo();
        },
        refreshFormOrderInfo() {
            this.$refs.drugFrom.getOrderInfo();
        },
    },
    computed: {
        generalPatientID() {
            if ((this.selectedPatient)) {
              if ((this.selectedPatient.patientId)) {
                if ((this.selectedPatient.patientId !== '')) {
                  if (this.selectedPatient.patientId.search(/\*\d+\*/) === -1) {
                    return this.selectedPatient.patientId;
                  }
                  return '';
                }
              }
            }

            return '';
        },
    },
    created() {
        scrollPageToTop();
        OrderService.orderInfo(this.$route.params.orderId).then((res) => {
            this.orderInfo = res;
            const patient = res.patients.find((p) => p.patientId === this.$route.params.patient);

            if (typeof patient !== 'undefined') {
                this.selectedPatient = patient;
            }
        });
    },
};
</script>
